const normalizeText = (value: unknown): string | null => {
  if (typeof value !== "string" && typeof value !== "number" && typeof value !== "bigint") {
    return null;
  }

  const trimmedValue = String(value).trim();
  return trimmedValue ? trimmedValue : null;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const getNormalizedRecordValue = (value: unknown, keys: readonly string[]): string | null => {
  if (!isRecord(value)) {
    return normalizeText(value);
  }

  for (const key of keys) {
    const normalizedValue = normalizeText(value[key]);
    if (normalizedValue) {
      return normalizedValue;
    }
  }

  return null;
};

const getUniqueValues = (
  values: unknown[],
  getValue: (value: unknown) => string | null
): string[] => {
  const byNormalized = new Map<string, string>();

  values.forEach((value) => {
    const normalizedValue = getValue(value);
    if (!normalizedValue) return;

    const normalizedKey = normalizedValue.toLowerCase();
    if (!byNormalized.has(normalizedKey)) {
      byNormalized.set(normalizedKey, normalizedValue);
    }
  });

  return Array.from(byNormalized.values());
};

export const normalizeContextText = (value: unknown): string | null => normalizeText(value);

export const getContextItemDisplayValue = (value: unknown): string | null =>
  getNormalizedRecordValue(value, [
    "topicSlug",
    "topicTitle",
    "title",
    "name",
    "label",
    "word",
    "slug",
    "topicId",
    "scenarioId",
    "wordId",
    "id",
    "value",
  ]);

export const getContextItemId = (value: unknown): string | null =>
  getNormalizedRecordValue(value, [
    "id",
    "topicId",
    "scenarioId",
    "wordId",
    "topicSlug",
    "slug",
    "value",
  ]);

export const getUniqueContextDisplayValues = (values: unknown[]): string[] =>
  getUniqueValues(values, getContextItemDisplayValue);

export const getUniqueContextIds = (values: unknown[]): string[] =>
  getUniqueValues(values, getContextItemId);
